export default __webpack_public_path__ + "static/media/ASR_BOLGE_SERVIS_ADETLERI.04913ec3.xlsx";